var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"bg-dacxi-white h-full",attrs:{"data-testid":"dacxi-app"}},[_c('Header'),_c('Content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }